export default __webpack_public_path__ + "static/media/1.81f50870.jpg";